<template>
  <div :class="{ 'h5-teacher-list': isH5, 'pc-teacher-list': !isH5 }">
    <p class="module-title">{{ moduleInfo.module_title }}</p>
    <p class="module-sub-title">{{ moduleInfo.module_sub_title }}</p>
    <ul
      class="list-wrap"
      v-if="moduleInfo.content_list && moduleInfo.content_list.length"
    >
      <li
        v-for="item in moduleInfo.content_list"
        :key="item.user_id"
        class="teacher-item"
        :class="{ 'only-one': moduleInfo.content_list.length === 1 }"
        @click="jumpUrl(item.user_id)"
      >
        <img
          class="t-cover"
          :src="item.avatar + '?imageView2/0/w/100'"
          alt=""
        />
        <div class="t-info">
          <p class="t-name">{{ item.org_nickname }}</p>
          <p class="t-desc">{{ item.profile }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isMobile: isMobile(),
      isH5: isH5(),
      inIosReview: false,
    };
  },
  created() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  methods: {
    jumpUrl(id) {
      let url = `/t/${id}`;
      if (this.inIosReview) {
        url = `${url}?inReview=1`;
      }
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-teacher-list {
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 24px 12px !important;
  margin-bottom: 20px;
  .module-title {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    margin-bottom: 4px;
  }
  .module-sub-title {
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    margin-bottom: 12px;
  }
  .list-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .teacher-item {
    width: 364px;
    height: 74px;
    background: #fafafa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 12px 22px 12px 12px;
    margin-bottom: 12px;
    cursor: pointer;
  }
  .t-cover {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 8px;
  }
  .t-info {
    // height: 100%;
    flex: 1;
    width: 0;
    .t-name {
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      margin-bottom: 4px;
    }
    .t-desc {
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  .teacher-item.only-one {
    width: 100%;
  }
}
.h5-teacher-list {
  background: #ffffff;
  border-radius: 0.32rem;
  padding: 0.32rem 0.32rem 0.05rem !important;
  margin-bottom: 0.4rem;
  .module-title {
    font-weight: 500;
    font-size: 0.4rem;
    color: #000000;
    line-height: 0.56rem;
    margin-bottom: 0.05rem;
  }
  .module-sub-title {
    font-weight: 400;
    font-size: 0.32rem;
    color: #515350;
    line-height: 0.44rem;
    margin-bottom: 0.27rem;
  }
  .teacher-item {
    width: 8.72rem;
    height: 1.71rem;
    background: #fafafa;
    border-radius: 0.21rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0.32rem 0.45rem 0.32rem 0.32rem;
    margin-bottom: 0.27rem;
  }
  .t-cover {
    width: 1.07rem;
    height: 1.07rem;
    border-radius: 0.21rem;
    object-fit: cover;
    margin-right: 0.13rem;
  }
  .t-info {
    // height: 100%;
    flex: 1;
    width: 0;
    .t-name {
      font-weight: 500;
      font-size: 0.37rem;
      color: #000000;
      line-height: 0.53rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      margin-bottom: 0.08rem;
    }
    .t-desc {
      font-weight: 400;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.4rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
</style>
